<app-submission-details-changes
  [previousInfo]="previousInfo$ | async"
  [newInfo]="newInfo$ | async"
  [previousInfoDisplayString]="previousInfoDisplayString$ | async"
  [newInfoDisplayString]="newInfoDisplayString$ | async" />
